import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import qs from 'query-string'
import { RecruitListQueryVariables } from 'generated/graphql'

const useRecruitFilterSyncToUrlQuery = (
  variables: RecruitListQueryVariables,
) => {
  const router = useRouter()

  const urlQueryRef = useRef<string>('')

  useEffect(() => {
    const convertVariableToQuery = (
      variables: RecruitListQueryVariables,
    ): string => {
      const { filterBy, activityOrder, page } = variables
      const query = {
        page,
        orderBy_direction: activityOrder?.direction,
        orderBy_field: activityOrder?.field,
      }
      if (filterBy) {
        Object.keys(filterBy).forEach((key) => {
          query[`filterBy_${key}`] = filterBy[key]
        })
      }
      if (!query) {
        return ''
      }
      const queryString = qs.stringify(query)

      return queryString
    }

    const updateUrlQuery = (queryString: string) => {
      const url = `${router.pathname}?${queryString}`
      router.replace(url, url, {
        shallow: true,
      })
    }

    const query = convertVariableToQuery(variables)

    if (query !== urlQueryRef.current) {
      urlQueryRef.current = query
      updateUrlQuery(query)
    }
  }, [variables])
}

export default useRecruitFilterSyncToUrlQuery
